// extracted by mini-css-extract-plugin
module.exports = {"accordionWrapper":"why-you-love-this-accordion_accordionWrapper__2_uLG"};